import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Icon, Button, Menu, Dropdown, message} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {
    fetchList, saveOrUpdate, detail, fetchArea, fetchCity, fetchChannels, disableCtrl,
    fetchSubdivideProLine, Update
} from '../../service/billingCtrl';
import moment from 'moment';
import {objectSerial, config} from 'Utils';

// import {fetchChannelList} from '../../service/home';
// import {getList, enableCtrl, disableCtrl} from './mockdata'

class BillingCtrlList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['开单管控配置'],
            key: 0,
            rows: [],
            total: 0,
            selectedKeys: [],
            filterBoxVisible: false,
            searchObj: {
                // product: '', // 产品明细类
                channelCode: this.channelData.split('|')[1] || '',
                p: 1,
                s: 10
            },
            channelList: [],
            subdivideProLine: []
        };

        this.pageChange = this.pageChange.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.goView = this.goView.bind(this);
        this.getData = this.getData.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.dropdownClick = this.dropdownClick.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    setList = (resultArray) => {
        var _arr = [];
        resultArray.forEach(ele => {
            _arr.push({
                value: ele.id,
                text: ele.name
            });
        })
        this.setState({
            channelList: _arr
        })
    }

    componentDidMount() {
        this.getSubdivideProLine();
        this.getData();
        if (!window.sessionStorage.getItem('channel_list')) {
            this.getChannel();
        } else {
            this.setList(JSON.parse(window.sessionStorage.getItem('channel_list')));
        }

        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    getChannel = () => {
        fetchChannels().then(result => {
            if (result.status && result.code == 200) {
                this.setList(result.data);
            } else {
                message.error(result.message);
            }
        });
    }

    getSubdivideProLine = () => {
        fetchSubdivideProLine().then(result => {
            if (result.status && result.code == 200) {
                result.data.push({id: 9999999, name: '', code: ''});
                this.setState({subdivideProLine: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    //请求数据
    getData() {
        fetchList(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                result.data.forEach(itm => {
                    this.state.subdivideProLine.forEach(item => {
                        if (item.CODE == itm.subdivideProLine) {
                            itm.subdivideProLineName = item.NAME;
                        }
                    })
                })
                console.log(result.data);
                this.setState({
                    rows: result.data,
                    total: result.total
                })
            } else {
                message.error(result.message);
            }
        })
    }

    //页面跳转
    goView(url) {
        hashHistory.push(url);
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceSubmit = (form) => {
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            this.getData();
        });

    };

    advanceReset = () => {
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, () => {
            this.getData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    };

    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.getData();
        });
    }

    exportChange() {
        let url = `${config.server}/api/v1/dmsOrderManage/exportExcel`;
        window.open(url);
    };


    dropdownClick({item, key, keyPath}) {
        let url = window.location.href
        // console.log(url)
        const {selectedKeys} = this.state;
        selectedKeys.push(key);
        this.setState({
            selectedKeys
        });
        var arr = key.split('_');

        if (arr[0] === '0') {
            this.goView('billingCtrl/add/' + this.state.rows[arr[1]].id);
        }

        // TODO
        // 也可参考category/list.js做法
        if (arr[0] === '1') {
            if (this.state.rows[arr[1]].status === true) {
                // 禁用配置
                Update({id: this.state.rows[arr[1]].id, status: 0}).then(result => {
                    if (result.status) {
                        message.success(result.message);
                        this.getData();
                    } else {
                        message.error(result.message);
                    }
                })
            } else {
                //启用配置
                Update({id: this.state.rows[arr[1]].id, status: 1}).then(result => {
                    if (result.status) {
                        message.success(result.message);
                        this.getData();
                    } else {
                        message.error(result.message);
                    }
                })
            }

        }

        if (arr[0] === '2') {
            Update({id: this.state.rows[arr[1]].id, removeFlag: 1}).then(result => {
                if (result.status) {
                    message.success(result.message);
                    this.getData();
                } else {
                    message.error(result.message);
                }
            })
        }
    }

    menu(index) {
        return (
            <Menu style={{width: '100px', textAlign: 'center'}} onClick={this.dropdownClick}>
                <Menu.Item key={`0_${index}`}>编辑</Menu.Item>
                <Menu.Item key={`1_${index}`}>{this.state.rows[index].status === true ? '禁用' : '启用'}</Menu.Item>
                <Menu.Item key={`2_${index}`}>删除</Menu.Item>
            </Menu>
        )
    }

    render() {
        const {opts, filterBoxVisible, rows, total, searchObj, channelList} = this.state;

        // 筛选弹窗
        const filterBoxProps = {
            showFlag: filterBoxVisible,
            advance: {
                fileds: [
                    {
                        name: 'detailName',
                        label: '产品明细类',
                        render: (txet, record, index) => {
                            // console.log(record)
                            return record.mainName + ',' + record.middleName + ',' + record.detailName
                        }
                    },
                    {
                        name: 'subdivideProLineName',
                        label: '细分产品线',
                    },
                    {
                        name: 'customerName',
                        label: '客户名称',
                    },
                    {
                        name: 'businessLineName',
                        label: '业务线',
                    },
                    // {
                    // 	name: 'channelCode',
                    // 	label: '渠道',
                    // 	defaultValue: '',
                    // 	options: channelList,
                    // 	text: '选择渠道',
                    // 	multiple: false,
                    // 	type: 'select'
                    // }
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            }
        };
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '产品分类',
                    dataIndex: 'detailName',
                    render: (text, record, index) => {
                        return (record.mainName ? record.mainName + ',' : '') + (record.middleName ? record.middleName + ',' : '') + (text ? text : '')
                    }
                },
                {
                    title: '细分产品线',
                    dataIndex: 'subdivideProLineName',
                },
                {
                    title: '片区',
                    dataIndex: 'areaName',
                    render: text => <span>{text}</span>
                }, {
                    title: '省市',
                    dataIndex: 'regionName'
                }, {
                    title: '客户名称',
                    dataIndex: 'customerName',
                },
                {
                    title: '业务线',
                    dataIndex: 'businessLineName'
                },
                {
                    title: '起始日期',
                    dataIndex: 'startDate',
                    render: (text) => {
                        return new Date(text).format('yyyy-MM-dd')
                    }
                },
                {
                    title: '结束日期',
                    dataIndex: 'endDate',
                    render: (text) => {
                        return new Date(text).format('yyyy-MM-dd')
                    }
                }
                , {
                    title: '创建人',
                    dataIndex: 'createdName'
                },
                {
                    title: '更新时间',
                    dataIndex: 'lastUpdatedDate',
                    render: (text) => {
                        return new Date(text).format('yyyy-MM-dd')
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    render: (text) => {
                        if (text === true) {
                            return '已启用'
                        } else {
                            return '已禁用'
                        }
                    }
                },
                {
                    title: '更多操作',
                    key: 'action',
                    className: 'status',
                    render: (text, record, index) => (
                        <Dropdown overlay={this.menu(index)}
                                  placement='bottomCenter'
                                  trigger={['click']}>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
                        </Dropdown>
                    )
                }],
            rows
        };
        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button icon="plus" onClick={this.goView.bind(this, '/billingCtrl/add/0')}>新增</Button>
                        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
                        <Button icon="export" onClick={this.exportChange}>导出</Button>
                        <FilterBox {...filterBoxProps}/>
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                </div>
            </div>
        )
    }
};
export default withRouter(BillingCtrlList);




// WEBPACK FOOTER //
// ./src/routes/billingCtrl/list.js